/**
 * Приводит номер к виду для `tel:`.
 *
 * Бэкенд отдаёт телефон строкой цифр (например `79339383331`), но иногда с ведущим `+`
 * или с междугородним `8` вместо `7` — из `8…` получился бы невалидный `+8…`.
 */
export function getPhoneLink(phone: string | null | undefined): string | null {
  if (!phone) {
    return null;
  }

  const digits = phone.replace(/\D/g, '');

  if (!digits) {
    return null;
  }

  return `+${digits.replace(/^8/, '7')}`;
}
